module.exports = __webpack_public_path__ + "Foundation.e20945d7.ttf";